module.exports = __webpack_public_path__ + "assets/22a5eb95b86dc8a7aedaa5a91eac8a22.png";